import React, { useEffect,useState } from "react";
import "./ForgotPassword.css";
import { Form } from 'react-bootstrap';
import {validatefogemail} from '../../Utils/validate';
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { useNavigate } from 'react-router-dom';
import { gettoastwarning } from '../../Utils/Common';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading,setLoading] = useState(false);
  const [error,setError] = useState();
  const [errors,setErrors] = useState({});
  const [inputs,setInputs] = useState({email:''});
 
  useEffect(() => {
    document.title = `ForgotPassword | bluefaucet`;
    document.getElementById('bodywrap').className='login';
  },[]); 
  
/* Start Value set */
const handleInputChange = (event) => {
  event.persist();
  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
}
/* End Value set */
//Start Forgot password email otp send
const handleSubmit = (event) => {
  event.preventDefault();
  const validationErrors = validatefogemail(inputs);
  const noErrors = Object.keys(validationErrors).length === 0;
  setError('');
  setErrors({});
  setErrors(validationErrors);
  if(noErrors){
    setLoading(true);
    let email=inputs.email;
    let formData = new FormData(); 
      formData.append('email', email);
      API.post('backoffice_forgot_password', formData)
        .then(response => {
          
        if(response.data.status === 0){
          //setError(response.data.message);
          setLoading(false); 
          gettoastwarning(response.data.message,'');
        }else{
          localStorage.setItem("email", email);
           navigate('/otp');
        }                  
      }).catch(error => {
         setLoading(false);
         gettoastwarning("Something went wrong. Please try again later.",'');
          //setError("Something went wrong. Please try again later.");
      });
  }
}

  return (
    <>
      <div className="container d-flex align-items-center justify-content-center mains">
        <div className="row w-100 flex-column flex-md-row justify-content-center">
          <div className="col-md-12 d-flex flex-column flex-md-row p-0 vach">
            {/* Right Section - Brand Info (Shown First on Mobile) */}
            <div className="col-md-5 right-section d-flex flex-column justify-content-center align-items-center order-md-2">
              <div className="right-logo">
                <img
                  src="/assests/images/bluefaucet-logo.png"
                  alt="BlueFaucet Logo"
                  className="img-fluid"
                />
              </div>
              <p>
                Welcome to BlueFaucet
                <br />
                Where we take care of your business.
              </p>
              <div className="position-relative hello w-100">
                <div className="de-1">
                  <img
                    src="/assests/images/round.png"
                    alt="Decor 1"
                    className="img-fluid"
                  />
                </div>
                <div className="de-2">
                  <img
                    src="/assests/images/trikon.png"
                    alt="Decor 2"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>

            {/* Left Section - Sign In Form */}
            <div className="col-md-7 left-section forgu d-flex flex-column justify-content-center">
              <h2>Forgot Password</h2>
              {error && (
                <div className="alert alert-danger">
              {error}
          </div>)}
              <form method="post" onSubmit={handleSubmit} enctype="multipart/form-data">
              <Form.Group className="mb-4">
                <div className="input-group mb-1">
                  <span className="input-group-text">
                    <img
                      src="/assests/images/email.png"
                      alt="Email Icon"
                      className="img-fluid"
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Email"
                    name="email"
                    onChange={handleInputChange}
                  />
                </div>
                {errors.email && (<p className="text-danger text-start mb-0">{errors.email}</p>)}
                </Form.Group>
                <button type="submit" className="btn w-100">
                  Send OTP
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {loading && (
       <div className="loadingClass">
        <img src={loader} alt="loader"/>
      </div>
       )}  
    </>
  );
};

export default ForgotPassword;
